import { useActionForm } from "@gadgetinc/react";
import { Link } from "react-router-dom";
import { api } from "../api";

export default function () {
  const {
    submit,
    register,
    formState: { isSubmitSuccessful, isSubmitting, errors },
    error,
  } = useActionForm(api.user.sendResetPassword);

  return (
    <>
      <style>{`
        .enhanced-auth-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 2rem;
        }

        .enhanced-auth-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          padding: 3rem;
          width: 100%;
          max-width: 450px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .enhanced-auth-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 70px rgba(0, 0, 0, 0.35);
        }

        .button-group {
          display: flex;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .enhanced-back-button {
          padding: 0.75rem 1.5rem;
          background: #f3f4f6;
          color: #374151;
          border: none;
          border-radius: 8px;
          font-size: 0.95rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }

        .enhanced-back-button:hover {
          background: #e5e7eb;
          transform: translateX(-2px);
        }

        .enhanced-form-title {
          margin-bottom: 2rem;
          text-align: center;
        }

        .brand-name {
          font-size: 2rem;
          font-weight: 700;
          color: #667eea;
          margin: 0 0 0.5rem 0;
        }

        .subtitle {
          font-size: 1.25rem;
          font-weight: 600;
          color: #374151;
          margin: 0;
        }

        .description {
          font-size: 0.95rem;
          color: #6b7280;
          margin-top: 0.75rem;
          line-height: 1.5;
        }

        .enhanced-auth-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .enhanced-form-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .enhanced-form-label {
          font-size: 0.9rem;
          font-weight: 600;
          color: #374151;
        }

        .enhanced-auth-input {
          padding: 0.875rem 1rem;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 1rem;
          transition: all 0.2s ease;
          outline: none;
        }

        .enhanced-auth-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .enhanced-auth-input::placeholder {
          color: #9ca3af;
        }

        .enhanced-button {
          padding: 0.875rem 1.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        }

        .enhanced-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
        }

        .enhanced-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .enhanced-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .loading-spinner {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-right: 0.5rem;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .error-message-container {
          padding: 1rem;
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 8px;
          color: #dc2626;
          font-size: 0.9rem;
          margin-bottom: 1rem;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .success-message-container {
          text-align: center;
          animation: fadeInScale 0.5s ease;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .success-icon {
          width: 64px;
          height: 64px;
          margin: 0 auto 1.5rem;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: white;
          animation: successPulse 0.6s ease;
        }

        @keyframes successPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        .success-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #10b981;
          margin: 0 0 0.75rem 0;
        }

        .success-text {
          font-size: 1rem;
          color: #6b7280;
          line-height: 1.6;
          margin-bottom: 2rem;
        }

        .auth-footer {
          margin-top: 2rem;
          text-align: center;
          font-size: 0.9rem;
          color: #6b7280;
        }

        .auth-footer a {
          color: #667eea;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.2s ease;
        }

        .auth-footer a:hover {
          color: #764ba2;
          text-decoration: underline;
        }
      `}</style>

      <div className="enhanced-auth-page">
        <div className="enhanced-auth-card">
          {isSubmitSuccessful ? (
            <div className="success-message-container">
              <div className="success-icon">✓</div>
              <h2 className="success-title">Email Sent!</h2>
              <p className="success-text">
                We've sent a password reset link to your email address. 
                Please check your inbox and follow the instructions to reset your password.
              </p>
              <Link to="/sign-in" className="enhanced-button" style={{ textDecoration: 'none', display: 'inline-block' }}>
                Return to Sign In
              </Link>
              <div className="auth-footer" style={{ marginTop: '1.5rem' }}>
                Didn't receive the email? Check your spam folder or{" "}
                <a href="#" onClick={(e) => { e.preventDefault(); window.location.reload(); }}>
                  try again
                </a>
              </div>
            </div>
          ) : (
            <>
              <div className="button-group">
                <Link to="/sign-in" className="enhanced-back-button">
                  ← Back to Sign In
                </Link>
              </div>

              <div className="enhanced-form-title">
                <h1 className="brand-name">Elevation EMS</h1>
                <h2 className="subtitle">Reset Your Password</h2>
                <p className="description">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
              </div>

              {error && (
                <div className="error-message-container">
                  <strong>Error:</strong> {error.message || "Failed to send reset email. Please try again."}
                </div>
              )}

              <form className="enhanced-auth-form" onSubmit={submit}>
                <div className="enhanced-form-group">
                  <label className="enhanced-form-label" htmlFor="email">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    className="enhanced-auth-input"
                    placeholder="Enter your email"
                    {...register("email")}
                    required
                  />
                  {errors?.email && (
                    <span style={{ color: '#dc2626', fontSize: '0.85rem' }}>
                      {errors.email.message}
                    </span>
                  )}
                </div>

                <button type="submit" className="enhanced-button" disabled={isSubmitting}>
                  {isSubmitting && <span className="loading-spinner" />}
                  {isSubmitting ? "Sending..." : "Send Reset Link"}
                </button>
              </form>

              <div className="auth-footer">
                Remember your password?{" "}
                <Link to="/sign-in">Sign in here</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
